import React, {useState} from 'react';
import {Grid, ThemeProvider} from "@mui/material";
import {theme} from "../Theme";
import {InvestAssistantContext, InvestAssistantContextType} from "./ContextType";
import {Stage1} from "./Stages/Stage1";
import {MoneyRange} from "./Types/MoneyRange";
import {ProgressInfoBox} from "./ProgressInfoBox";
import {Stage2} from "./Stages/Stage2";
import {Stage3} from "./Stages/Stage3";
import {SlideDirection} from "./Types/SlideDirection";
import {InvestAssistantStages} from "./InvestAssistantStages";
import {fireEvent} from "../Tracking/FireEvent";


interface InvestAssistantProps {
    config: {
    }
}

export function InvestAssistant(props: InvestAssistantProps) {

    const [numStages, setNumStages] = useState(3);
    const [currentStage, setCurrentStage] = useState(1);
    const [currentStageNumberToDisplay, setCurrentStageNumberToDisplay] = useState(1);
    const [maxStageReached, setMaxStageReached] = useState(0);
    const [equityCapitalState, setEquityCapitalState] = useState<MoneyRange>();
    const [monthlyInvestState, setMonthlyInvestState] = useState<MoneyRange>();
    const [yourName, setYourName] = useState('');
    const [yourMail, setYourMail] = useState('');
    const [yourMobile, setYourMobile] = useState('');
    const [slideDirection, setSlideDirection] = useState(SlideDirection.Left);
    const [newsletterConsent, setNewsletterConsent] = useState(true);
    const [source, setSource] = useState('invest');
    const [selectedPath, setSelectedPath] = useState('normal');
    const [bundesland, setBundesland] = useState('');
    const [iidConsent, setIidConsent] = useState(false);

    let ctx = {
        type: "extern",
        newsletterConsent: newsletterConsent,
        setNewsletterConsent: setNewsletterConsent,
        currentStageNumberToDisplay: currentStageNumberToDisplay,
        equityCapitalState: equityCapitalState,
        setEquityCapitalState: setEquityCapitalState,
        monthlyInvestState: monthlyInvestState,
        setMonthlyInvestState: setMonthlyInvestState,
        yourName: yourName,
        setYourName: setYourName,
        yourMail: yourMail,
        setYourMail: setYourMail,
        yourMobile: yourMobile,
        setYourMobile: setYourMobile,
        numStages: numStages,
        setNumStages: setNumStages,
        currentStage: currentStage,
        handleGoToStage: (stage: number) => setCurrentStage(stage),
        handleNext: (increaseStepNumber: boolean) => {
            setSlideDirection(SlideDirection.Right);
            if (increaseStepNumber) {
                setCurrentStageNumberToDisplay(currentStageNumberToDisplay + 1);
            }
            if (maxStageReached < currentStage) {
                fireEvent('invest-assistant-page-' + currentStage + '-completed');
            }

            setMaxStageReached(Math.max(maxStageReached, currentStage));
            setCurrentStage(currentStage + 1);
        },
        handlePrev: (decreaseStepNumber: boolean) => {
            setSlideDirection(SlideDirection.Left);
            if (decreaseStepNumber) {
                setCurrentStageNumberToDisplay(currentStageNumberToDisplay - 1);
            }
            setCurrentStage(currentStage - 1);
        },
        slideDirection: slideDirection,
        setSlideDirection: setSlideDirection,
        source: source,
        setSource: setSource,
        selectedPath: selectedPath,
        setSelectedPath: setSelectedPath,
        bundesland: bundesland,
        setBundesland: setBundesland,
        iidConsent: iidConsent,
        setIidConsent: setIidConsent,
    } as InvestAssistantContextType;

    return (
        <ThemeProvider theme={theme}>
            <InvestAssistantContext.Provider value={ctx}>
                <Grid container>
                    <ProgressInfoBox/>
                    <InvestAssistantStages>
                        <Stage1/>
                        <Stage2/>
                        <Stage3/>
                    </InvestAssistantStages>
                </Grid>
            </InvestAssistantContext.Provider>
        </ThemeProvider>
    );
}